/**
 * Catálogo do domínio `taf` (T53, CAT-02).
 *
 * Origem: `src/shared/autorizacao/produto.ts:19-27`. TAF é domínio próprio no
 * vocabulário (`DOMINIOS`) e tem os três níveis em `LEGADO` (`taf`,
 * `editor_taf`, `admin_taf`); só o arquivo imperativo é que os hospeda junto de
 * Produto.
 */
import type { NomePapel, Papel } from "../catalogo/vocabulario";

export const PAPEIS_TAF = {
  "taf.admin": {
    dominio: "taf",
    nivel: "admin",
    concessoes: [{ acoes: ["manage"], recurso: "TAF" }],
  },
  "taf.escrita": {
    dominio: "taf",
    nivel: "escrita",
    concessoes: [{ acoes: ["read", "update"], recurso: "TAF" }],
  },
  "taf.leitura": {
    dominio: "taf",
    nivel: "leitura",
    concessoes: [{ acoes: ["read"], recurso: "TAF" }],
  },
} as const satisfies Partial<Record<NomePapel, Papel>>;
